import React, { Component } from 'react'
import { Container, Navbar } from 'react-bootstrap'
import './navbar.scss'
import { Link } from 'react-scroll';

class NavBar extends Component {

    setNavExpanded = (expanded) => {
        this.setState({ navExpanded: expanded });
    }

    closeNav = () => {
        this.setState({ navExpanded: false });
    }

    state = {
        expanded: {}
    }

  render() {
    let navBarClass = 'navbar-default';
    if (this.props.scrolled) {
        navBarClass += ' scrolled';
    }

    return (
        <Navbar onToggle={this.setNavExpanded} expanded={this.state.navExpanded} className={navBarClass} variant="dark" id="mainNav" expand="lg" fixed="top">
            <Container>
                <Navbar.Brand as={Link} to="/">ERC Solutions</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item mr-0 mr-lg-5">
                            <Link
                                activeClass="active"
                                className="nav-link"
                                to="home"
                                spy={true}
                                smooth={true}
                                offset={-56}
                                duration={800}
                                onClick={this.closeNav} >
                                Home
                            </Link>
                        </li>
                        <li className="nav-item mr-0 mr-lg-5">
                            <Link
                                activeClass="active"
                                className="nav-link"
                                to="about"
                                spy={true}
                                smooth={true}
                                offset={-56}
                                duration={800}
                                onClick={this.closeNav}>
                                About
                            </Link>
                        </li>
                        <li className="nav-item mr-0 mr-lg-5">
                            <Link
                                activeClass="active"
                                className="nav-link"
                                to="team"
                                spy={true}
                                smooth={true}
                                offset={-56}
                                duration={800}
                                onClick={this.closeNav}>
                                Team
                            </Link>
                        </li>
                        <li className="nav-item mr-0 mr-lg-5">
                            <Link
                                activeClass="active"
                                className="nav-link"
                                to="skills"
                                spy={true}
                                smooth={true}
                                offset={-56}
                                duration={800}
                                onClick={this.closeNav}>
                                Skills
                            </Link>
                        </li>
                        <li className="nav-item mr-0 mr-lg-5">
                            <Link
                                activeClass="active"
                                className="nav-link"
                                to="plans"
                                spy={true}
                                smooth={true}
                                offset={-56}
                                duration={800}
                                onClick={this.closeNav}>
                                Plans
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                activeClass="active"
                                className="nav-link"
                                to="contact"
                                spy={true}
                                smooth={true}
                                offset={-56}
                                duration={800}
                                onClick={this.closeNav}>
                                Contact
                              </Link>
                        </li>
                    </ul>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js